import { ApolloClient, NormalizedCacheObject, useMutation, useQuery } from '@apollo/client';
import { PaymentSettingsData, UpsertPaymentSettingsData, UpsertPaymentSettingsVars } from '../gql-types';

import ApolloClientService from '../services/ApolloClientService';
import Config from '../config';
import GraphQL from '../gql';
import PaymentSettings from '../../siteadmin/models/PaymentSettings';

let siteAdminApolloClient: ApolloClient<NormalizedCacheObject> = null;

function usePaymentSettings() {
  if (!siteAdminApolloClient) {
    siteAdminApolloClient = ApolloClientService.create(Config.SITE_ADMIN_GQL);
  }

 const { loading, error, data } = useQuery<PaymentSettingsData>(
    GraphQL.Query.PAYMENT_SETTINGS,
    {
      client: siteAdminApolloClient
    }
  );

  const [_upsertPaymentSettings, { loading: updating, error: updateError, data: updatedData }]
    = useMutation<UpsertPaymentSettingsData, UpsertPaymentSettingsVars>(
      GraphQL.Mutation.UPSERT_PAYMENT_SETTINGS,
      {
        client: siteAdminApolloClient,
        refetchQueries: [{
          query: GraphQL.Query.PAYMENT_SETTINGS,
        }]
      }
    );

  function upsertPaymentSettings(paymentSettings: PaymentSettings) {
    const { clientId, currency } = paymentSettings;
    _upsertPaymentSettings({
      variables: {
        input: {
          clientId,
          currency
        }
      }
    })
  }

  return {
    loading,
    error: !!error,
    paymentSettings: data?.paymentSettings,
    upsertPaymentSettings,
    updating,
    updateError: !!updateError,
    updated: updatedData?.upsertPaymentSettings
  };
}

export default usePaymentSettings;
